export const RECIPIENT_TYPE = 'recipientType';
export const RECIPIENT_ID = 'recipientId';